<template>
  <div id="app">
    Economica
    {{ this.$route.path }}
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  }
}
</script>

<style scoped>
</style>
